import { env } from '../../../../../common/util'

const ownerRoleId = { dev: '5raikjdb92ws5ju6', staging: '9zip1cx4oi5lt3ii', prod: 'c7jximvkjagbh0n8' }
const adminRoleId = { dev: 'dh90p1kwu2s84wes', staging: '2fj5t1nz70wd4f4l', prod: '1cuebwhxuxhzdvvi' }
const professionalRoleId = { dev: '10cyp13r3pvudt93', staging: '1304esp8q7uxgc9n', prod: '98rhc42q33x2vqjl' }
const financialAdvisorRoleId = { dev: '3bh6d3yl7ux2oczi', staging: '2rv4pp0g2w94zngd', prod: 'ebarfbpym8donp92' }
const anonymousRoleId = { dev: '2r45tit7ozgxplae', staging: 'ausw8u0lwo3gufyh', prod: 'apz6huperw0oad7p' }
const clientRoleId = { dev: '4zzk87iet51f63fb', staging: '8r3rt8guo6pogzz4', prod: '6qvung11dez0nlq6' }
const taxAdvisorRoleId = { dev: '550m60ftbuy8hmyo', staging: '0z2nbu18q1kmij61', prod: '5s8614cwiqsm2tsw' }
const legalAdvisorRoleId = { dev: 'ddb1nzrr1d8f3ev7', staging: '3y6trpyd4qyfjru2', prod: '51tqayhmo8u287to' }
const insuranceAdvisorRoleId = { dev: '5mplgl46g3o8i55v', staging: '8w1cuc0ea6a2k8qo', prod: 'd49h1bx2kfkazxyr' }
const customerServiceAgentRoleId = { dev: '9qje62wnpiwivgmn', staging: 'drzhd96l6cb3qcyt', prod: '5vg3r8vzkq81jkyl' }
const adminAssistantRoleId = { dev: 'fsjjasjrvihxtpuk', staging: 'dsqeuufsbuxejirp', prod: 'nb5aphuvqngljca3' }

export const ASSIGNMENT_ROLE_NAME_MAPPING: { [key: string]: string } = {
  [ownerRoleId[env]]: 'Financial Advisors',
  [adminRoleId[env]]: 'Financial Advisors',
  [professionalRoleId[env]]: 'Financial Advisors',
  [anonymousRoleId[env]]: 'Clients',
  [clientRoleId[env]]: 'Clients',
  [taxAdvisorRoleId[env]]: 'Tax Advisors',
  [legalAdvisorRoleId[env]]: 'Legal Advisors',
  [insuranceAdvisorRoleId[env]]: 'Insurance Advisors',
  [customerServiceAgentRoleId[env]]: 'Customer Service Agents',
  [adminAssistantRoleId[env]]: 'Administrative Assistants',
}

export const CONSENT_EXCLUDED_ROLES = [
  ownerRoleId[env],
  adminRoleId[env],
  professionalRoleId[env],
  financialAdvisorRoleId[env],
  adminAssistantRoleId[env],
  taxAdvisorRoleId[env],
  legalAdvisorRoleId[env],
  insuranceAdvisorRoleId[env],
]
